import React from 'react'
import styled from 'styled-components'
import ProjectCardLanding from './ProjectCardLanding'

const Section = styled.section`
  overflow: hidden;

  & h2 {
    color: ${(props) => props.theme.color.greyAlt};
    font-weight: 600;
    margin-bottom: 0;
    font-size: clamp(3rem, 14vw, 250px);
    line-height: 0.75;
    white-space: nowrap;
  }

  @media (min-width: 992px) {
    padding-top: 97px;
    padding-bottom: 87px;

    .projecten-wrapper {
      margin-top: -25px;
    }
  }

  @media (max-width: 991.98px) {
    padding-block: 2rem;
  }
`

const Grid = styled.div`
  position: relative;
  z-index: 2;
`

function ProjectsLanding({ projects }) {
  const items = projects.projects || []

  return (
    <Section>
      <div className="container">
        <h2>{projects.title}</h2>

        <Grid className="projecten-wrapper row">
          {items.map((project) => (
            <div className="col-lg-6 mb-5" key={project.id}>
              <ProjectCardLanding
                src={project.projectrecap && project.projectrecap.banner}
                title={project.title}
                location={project.projectrecap && project.projectrecap.locatie}
                to={project.uri}
              />
            </div>
          ))}
        </Grid>
      </div>
    </Section>
  )
}

export default ProjectsLanding
